import { render, staticRenderFns } from "./request-confirm.vue?vue&type=template&id=452c7154&scoped=true&"
import script from "./request-confirm.vue?vue&type=script&lang=js&"
export * from "./request-confirm.vue?vue&type=script&lang=js&"
import style0 from "./request-confirm.vue?vue&type=style&index=0&id=452c7154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c7154",
  null
  
)

export default component.exports